import React, { useState,useEffect,useRef } from "react";
import { useParams } from "react-router-dom";
import axios from 'axios';

import { useRecoilState } from "recoil";
import { BranchMenus } from "../../components/recoil/atoms/Menus";

import HeaderBranchTitle from "../components/includes/HeaderBranchTitle";

import { ChangeSimpleDateString,PassedMonths,GetChildrenState,escapeHtml,unescapeHtml,isObjEmpty,isNull,SetEmptyInputFile,GetBookName } from "../../components/common/Common";
import cancelIcon from "../../img/icon/icon-cancel.svg";
import "../../css/style.css";


//플라이 진도표 수업별 정리
const FlyDetail = () => {
  const { clc_idx } = useParams();

  const fileRef= useRef(null);
  const [varBranchMenus,setBranchMenus] = useRecoilState(BranchMenus);

  const [varClassChildrenInfo,setClassChildrenInfo] = useState({}); //원생/클라스 정보
  const [varStudyStepIndex,setStudyStepIndex] = useState(0); //선택된 chapter

  const [varEvaluationList,setEvaluationList] = useState([]); //진도별 평가 목록
  const [varEvaluationInfo,setEvaluationInfo] = useState({}); //선택된 평가 정보

  const [varFlyChecksList,setFlyChecksList] = useState([]);   //전체 플라이 교육정보
  const [varFlyClassList,setFlyClassList] = useState([]); 
  const [varFlyStepList,setFlyStepList] = useState([]); 
  const [varFlyChapterList,setFlyChapterList] = useState([]); 

  //평가할 원생/클래스정보 호출
  const GetEvaluationList = async() => {
    const sendData = {clc_idx:clc_idx};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/branch_get_childrens_fly`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        const childrenInfo = datas.results[0];
        setClassChildrenInfo(childrenInfo);

        //전체 플라이 교육정보
        const flyalls = datas.flyalls;
        setFlyChecksList(flyalls);

        //플라이 클래스 과목
        const flythemes = datas.flythemes;
        setFlyClassList(flythemes);

        //차수
        const flyStepList = [];
        const flyChapterList = [];
        for(var i=1; i <= 12; i++) {
          flyStepList.push(i);
          if(i <= 4) {
            flyChapterList.push(i);
          }
        }
        setFlyStepList(flyStepList);
        setFlyChapterList(flyChapterList);
        
        //평가 결과 정보 읽기
        GetEvaluationInformation(childrenInfo.cl_idx,childrenInfo.ch_idx);
      }
    });
  }

  //평가 결과 정보 읽기
  const GetEvaluationInformation = async(cl_idx,ch_idx) => {
    const sendData = {cl_idx:cl_idx,ch_idx:ch_idx};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/branch_get_evaluation_fly`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        const evaluationList = datas.evaluationList;
        setEvaluationList(evaluationList);
        setStudyStepIndex(evaluationList[0].csc_idx);
      }
    });
  }

  //최초실행부
  useEffect(() => {
    console.log(varBranchMenus);
    setBranchMenus({showMenu:true,gotoMain:1});
    GetEvaluationList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if(varStudyStepIndex > 0) {
      //선택된 단계에 대한 원생 + 평가 정보
      const studyStepData = varEvaluationList.find(el=>el.csc_idx === varStudyStepIndex);
      console.log(studyStepData);
      if(isNull(studyStepData.vts_idx)) studyStepData.vts_idx = 1;
      if(isNull(studyStepData.vtc_chapter)) studyStepData.vtc_chapter = 1;
      studyStepData.bookname = GetBookName(studyStepData.vt_name,studyStepData.vts_idx);
      setEvaluationInfo(studyStepData);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [varStudyStepIndex]);

  //단계 변경
  const onChangeStudyStepHandler = (e) => {
    const csc_idx = Number(e.currentTarget.value);
    setStudyStepIndex(csc_idx);
  }

  //과목/단계/Chapter 선택
  const onChangeClassStepHandler = (e) => {
    const {name,value } = e.currentTarget;
    if(name === "vt_idx") {
      if(Number(value) === 0) {
        setEvaluationInfo({...varEvaluationInfo,vt_idx:0,bookname:"",vtc_purpose_direct:"",vtc_purpose_indirect:"",vtc_next_class:""});
      } else {
        const selData = varFlyClassList.find(el=>el.vt_idx === Number(value));
        let vts_idx = 1;
        if(!isNull(varEvaluationInfo.vts_idx)) vts_idx = varEvaluationInfo.vts_idx;
        let bookname = GetBookName(selData.vt_name,vts_idx); 
        const flyData = varFlyChecksList.find(el=>el.vt_idx===Number(value) && el.vts_idx===varEvaluationInfo.vts_idx && el.vtc_chapter===varEvaluationInfo.vtc_chapter);
        if(isNull(flyData)) setEvaluationInfo({...varEvaluationInfo,[name]:Number(value),bookname:bookname});
        else setEvaluationInfo({...varEvaluationInfo,[name]:Number(value),bookname:bookname,vtc_purpose_direct:flyData.vtc_purpose_direct,
          vtc_purpose_indirect:flyData.vtc_purpose_indirect,vtc_next_class:flyData.vtc_next_class,vtc_idx:flyData.vtc_idx});
      }
    } else if(name === "vts_idx") {
        const selData = varFlyClassList.find(el=>el.vt_idx === varEvaluationInfo.vt_idx);
        let bookname = GetBookName(selData.vt_name,Number(value)); 
        const flyData = varFlyChecksList.find(el=>el.vt_idx===varEvaluationInfo.vt_idx && el.vts_idx===Number(value) && el.vtc_chapter===varEvaluationInfo.vtc_chapter);
        if(isNull(flyData)) setEvaluationInfo({...varEvaluationInfo,[name]:Number(value),bookname:bookname});
        else setEvaluationInfo({...varEvaluationInfo,[name]:Number(value),bookname:bookname,vtc_purpose_direct:flyData.vtc_purpose_direct,
            vtc_purpose_indirect:flyData.vtc_purpose_indirect,vtc_next_class:flyData.vtc_next_class,vtc_idx:flyData.vtc_idx});
    } else if(name === "vtc_chapter") {
      const flyData = varFlyChecksList.find(el=>el.vt_idx===varEvaluationInfo.vt_idx && el.vts_idx===varEvaluationInfo.vts_idx && el.vtc_chapter===Number(value));
      if(isNull(flyData)) setEvaluationInfo({...varEvaluationInfo,vtc_chapter:Number(value)});
      else setEvaluationInfo({...varEvaluationInfo,vtc_chapter:Number(value),vtc_purpose_direct:flyData.vtc_purpose_direct,
            vtc_purpose_indirect:flyData.vtc_purpose_indirect,vtc_next_class:flyData.vtc_next_class,vtc_idx:flyData.vtc_idx});
    } else if(name === "ev_memo") {
      setEvaluationInfo({...varEvaluationInfo,ev_memo:escapeHtml(value)});
    } else {
      setEvaluationInfo({...varEvaluationInfo,[name]:Number(value)});
    }
  }

  //첨부파일 삭제
  const onDeleteAttachFileHandler = async(e) => {
    e.preventDefault();
    if(!isNull(varEvaluationInfo.ev_file) && varEvaluationInfo.ev_idx > 0) {
      const sendData = {ev_idx:varEvaluationInfo.ev_idx};
      console.log(sendData);
      await axios.post(`${process.env.REACT_APP_HOST}/branch_delete_evaluation_fly`,sendData).then((res) => {
        const datas = res.data;
        console.log(datas);
        if(datas.retvalue === 1)  setEvaluationInfo({...varEvaluationInfo,ev_attach:0,ev_file:'',ev_real_file:''});
        else alert(datas.message);
      });
    } else {
      setEvaluationInfo({...varEvaluationInfo,ev_attach:0,ev_real_file:''});
    }
    const fileBox = fileRef.current;
    SetEmptyInputFile(fileBox);
  }
  
  //첨부파일
  const SelectAttachFileHandler = (e) => {
    e.preventDefault();
    fileRef.current.click();
  }
  const SelectedAttachFileHandler = (e) => {
    e.preventDefault();
    const uploadFile = fileRef.current.files[0];
    console.log(uploadFile);
    //변수값 재조정
    setEvaluationInfo({...varEvaluationInfo, ev_attach:1,ev_real_file:uploadFile.name});
  }
  const onBackPageHandler = (e) => {
    e.preventDefault();
    window.history.back();
  }

  //평가서 저장 - 첨부파일
  const onUpdateEvaluationHandler = async(e) => {
    if(varEvaluationInfo.ev_memo === "") {
      alert('세부평가내용을 먼저 입력하십시오.'); return false;
    }
    if(!window.confirm('플라이진도표를 저장합니까?')) return false;

    if(varEvaluationInfo.ev_attach===1 && !isNull(fileRef.current.files[0])) {
      console.log(fileRef.current.files[0].name);
      let formData = new FormData();
      formData.append('flys',fileRef.current.files[0]);
      await axios.post(`${process.env.REACT_APP_HOST}/flys`,formData).then((res) => {
        const datas = res.data;
        console.log(datas);
        if(datas.retvalue === 1) {
          const fileName = datas.fileName;
          UpdateEveluationInformation(fileName);
        } else {
          alert(datas.message);
        }
      });
    } else {
      UpdateEveluationInformation("");
    }
  }

  //평가서 정보 저장
  const UpdateEveluationInformation = async(fileName) => {
    const sendData = {dataInfo:varEvaluationInfo,fileName:fileName};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/branch_update_evaluation_fly`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      const ev_idx = datas.ev_idx;
      if(datas.retvalue === 1)  UpdateStudyChildrensInformation(ev_idx);
      else alert(datas.message);
    });
  }
  //원생정보에 평가유무 등록
  //평가서 정보 저장
  const UpdateStudyChildrensInformation = async(ev_idx) => {
    const sendData = {csc_idx:varEvaluationInfo.csc_idx,ev_idx:ev_idx,dataInfo:varClassChildrenInfo};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/branch_update_information_fly`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      const evalsData = datas.evaluations[0];
      evalsData.bookname = GetBookName(evalsData.vt_name,evalsData.vts_idx);
      setEvaluationInfo(evalsData);
      console.log(evalsData);

      //배열에  재저장
      const newList = [...varEvaluationList];
      const findIndex = newList.find(el=>el.csc_idx === varEvaluationInfo.csc_idx);
      newList[findIndex] = evalsData;
      setEvaluationList(newList);
      alert(datas.message);
    });
  }  
  
  return isObjEmpty(varEvaluationInfo)?null:(
    <div className="vh-content">
      <HeaderBranchTitle varPageTitle={varClassChildrenInfo.csc_ev_idx === 0?'플라이 진도표 생성':'플라이 진도표 수정'} varBackString={'/Branch/AnalysisSet'}/>
      <div className="vh-content-body ct-mdt-wrap" style={{marginTop:"60px"}}>
        <div className="mdt-con fly-add-con">
          <div className="center-wrap">
            <div className="mdt-info">
							<div className="line">
								<div className="name">{varClassChildrenInfo.ch_name} {PassedMonths(varClassChildrenInfo.ch_birthday)}개월</div>
								<div>{ChangeSimpleDateString(varClassChildrenInfo.ch_birthday)} ({GetChildrenState(varClassChildrenInfo.ch_status)})</div>
							</div>
							<ul>
								<li>
									<p>학기명</p>
									<div>{varClassChildrenInfo.sm_name}</div>
								</li>
								<li>
									<p>클래스</p>
									<div>{varClassChildrenInfo.cl_name}</div>
								</li>
								<li>
									<p>차수</p>
									<div>{varClassChildrenInfo.pass_cnt}/{varClassChildrenInfo.tstudys}</div>
								</li>
							</ul>
            </div>
            {/* 평가할 플라이 수업 선택  */}
            <div className="select-wrap" style={{flexDirection:"row",justifyContent:"space-between"}}>
							<label style={{paddingTop:"5px"}}>원생 수업 단계</label>
							<select name="" value={varStudyStepIndex||0} style={{width:"120px"}} onChange={e=>onChangeStudyStepHandler(e)}>
                <option value={0}>단계 선택</option>
                {varEvaluationList.map((studys,i)=>(
                  <option key={'studys_'+i} value={studys.csc_idx}>{studys.cs_index} 단계</option>
                ))}
              </select>
						</div>
            {/* 플라이 진도표 */}
            {isObjEmpty(varEvaluationInfo) || varFlyClassList.length===0?null:
              <div className="mdt-box fly-box">
                <p className="mdt-tit">플라이 진도표</p>
                <div className="fly-view-box">
                  <div className="fly-input-line">
                    <p>평가 과목</p>
                    <div>
                      <select name="vt_idx" value={varEvaluationInfo.vt_idx||0} style={{width:"150px"}} onChange={e=>onChangeClassStepHandler(e)}>
                        <option value={0}>과목 선택</option>
                        {varFlyClassList.map((checks,i)=>(
                          <option key={'checks_'+i} value={checks.vt_idx}>{`${checks.vt_theme} / ${checks.vt_name}`}</option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className="fly-input-line">
                    <p>평가 단계</p>
                    <div>
                      <select name="vts_idx" value={varEvaluationInfo.vts_idx||0} style={{width:"150px"}} onChange={e=>onChangeClassStepHandler(e)}>
                        {varFlyStepList.map((steps,i)=>(
                          <option key={'steps_'+i} value={steps}>{steps} 단계</option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className="fly-input-line">
                    <p>Chapter</p>
                    <div>
                      <select name="vtc_chapter" value={varEvaluationInfo.vtc_chapter||0} style={{width:"150px"}} onChange={e=>onChangeClassStepHandler(e)}>
                        {varFlyChapterList.map((chapters,i)=>(
                          <option key={'chapters_'+i} value={chapters}>Chapter{chapters}</option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className="fly-input-line">
                    <p>교재</p>
                    <div>
                      <input type="text" className="read-only" style={{width:"150px"}} value={varEvaluationInfo.bookname||""} readOnly />
                    </div>
                  </div>
                  <div className="fly-input-line">
                    <p>직접 목적</p>
                    <div>
                      <input type="text" className="read-only" value={unescapeHtml(varEvaluationInfo.vtc_purpose_direct)} readOnly/>
                    </div>
                  </div>
                  <div className="fly-input-line">
                    <p>간접 목적</p>
                    <div>
                      <input type="text" className="read-only" value={unescapeHtml(varEvaluationInfo.vtc_purpose_indirect)} readOnly/>
                    </div>
                  </div>
                  <div className="fly-text-line">
                    <p>다음 수업</p>
                    <div>
                      <textarea className="read-only" value={unescapeHtml(varEvaluationInfo.vtc_next_class)} readOnly/>
                    </div>
                  </div>
                  <div className="fly-text-line">
                    <p>세부 평가</p>
                    <div>
                      <textarea name="ev_memo" value={unescapeHtml(varEvaluationInfo.ev_memo)} onChange={e=>onChangeClassStepHandler(e)}/>
                    </div>
                  </div>
                  <div className="form-group">
                    <p className="form-label">첨부파일</p>
                    <label className="" htmlFor="file">
                      <div className="btn-upload" onClick={e=>SelectAttachFileHandler(e)}>첨부 파일 선택하기</div>
                    </label>
                    <input type="file" ref={fileRef} id="file" onChange={e=>SelectedAttachFileHandler(e)}/>
                    <div className="file-box" style={varEvaluationInfo.ev_attach===1?{}:{display:"none"}}>
                      <p>{varEvaluationInfo.ev_real_file}</p>
                      <div className="btn-cancel" onClick={e=>onDeleteAttachFileHandler(e)}>
                        <img src={cancelIcon}  alt=""/>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            }
            <div className="form-contoller bt-btn">
							<button className="form-contoller-btn btn-no" onClick={e=>onBackPageHandler(e)}>취소</button>
							<button className="form-contoller-btn btn-yes" onClick={e=>onUpdateEvaluationHandler(e)}>확인</button>
						</div>
          </div>
        </div>
      </div>
    </div>	
  );
}
export default FlyDetail;